import React, { useState } from 'react';
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import { Link, useNavigate } from "react-router-dom";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import { useSelector } from 'react-redux';
import CopyItem from "../components/common/CopyItem";
import PageHeader from "../components/gamePlayComponents/PageHeader";

export const contactEmail = 'CapitalClues@gmail.com';

export const APP_STORE_URL = 'https://apps.apple.com/us/app/capital-clues/id1588907053';
export const PLAY_STORE_URL = 'https://play.google.com/store/apps/details?id=com.capitalclues.capitalclues';

// Google Form config for Capital Clues Feedback (from form HTML)
const GOOGLE_FORM_ACTION = 'https://docs.google.com/forms/u/0/d/e/1FAIpQLSfboRB0-yq0PwdqBLpTcfvrnsGc8Cg7VT0ltiYxZnAh7iDqBA/formResponse';
const ENTRY_EMAIL = 'entry.621387594';
const ENTRY_THOUGHTS = 'entry.149233382';
const FORM_FBZX = '-4479240095621363603';

const Feedback = (props) => {
  const navigate = useNavigate();
  const platform = useSelector((state) => state.platform);

  const [email, setEmail] = useState('');
  const [thoughts, setThoughts] = useState('');
  const [submitted, setSubmitted] = useState(false);

  const isCapitalCluesFeedback = props.sourceURL?.includes('1FAIpQLSfboRB0-yq0PwdqBLpTcfvrnsGc8Cg7VT0ltiYxZnAh7iDqBA');

  const handleSubmit = (e) => {
    e.preventDefault();
    const form = e.target;
    form.submit();
    setSubmitted(true);
    setEmail('');
    setThoughts('');
    form.reset();
  };

  const handleClear = () => {
    setEmail('');
    setThoughts('');
  };

  const handleSubmitAnother = () => {
    setSubmitted(false);
    setEmail('');
    setThoughts('');
  };

  const backButton = (
    <Button variant="contained" color="primary" style={{ margin: '8px 0' }} onClick={() => navigate(-1)}>
      Go back
    </Button>
  );

  // Inline MUI form for Capital Clues Feedback
  if (isCapitalCluesFeedback) {
    return (
      <>
        <Box
          component="div"
          sx={{
            display: 'flex',
            flexDirection: 'column',
            bgcolor: 'background.default',
            zIndex: 2,
            position: 'absolute',
            top: 0,
            left: 0,
            padding: 2,
            paddingTop: platform.statusBarHeight + 16 + 'px',
            maxWidth: '100%',
          }}
        >
          <PageHeader goBack title="Feedback" />

          {submitted ? (
            <Box sx={{ py: 2 }}>
              <Typography sx={{ mb: 2 }}>Your feedback was successfully submitted.</Typography>
              <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
                <Button variant="contained" color="primary" onClick={() => navigate(-1)}>
                  Return
                </Button>
                <Button variant="outlined" onClick={handleSubmitAnother}>
                  Submit another response
                </Button>
              </Box>
            </Box>
          ) : (
            <>
              <Box component="form" action={GOOGLE_FORM_ACTION} method="POST" onSubmit={handleSubmit} target="feedback-form-target">
                <input type="hidden" name={ENTRY_EMAIL} value={email} readOnly />
                <input type="hidden" name={ENTRY_THOUGHTS} value={thoughts} readOnly />
                <input type="hidden" name="fvv" value="1" />
                <input type="hidden" name="pageHistory" value="0" />
                <input type="hidden" name="fbzx" value={FORM_FBZX} />
                <input type="hidden" name="partialResponse" value={JSON.stringify([null, null, FORM_FBZX])} />

                <TextField
                  fullWidth
                  label="Your email"
                  placeholder="Optional: only if you want us to write back"
                  type="email"
                  name="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  sx={{ mb: 2 }}
                  autoComplete="email"
                />
                <TextField
                  fullWidth
                  label="Your thoughts:"
                  placeholder="Your answer"
                  multiline
                  minRows={4}
                  name="thoughts"
                  value={thoughts}
                  onChange={(e) => setThoughts(e.target.value)}
                  sx={{ mb: 2 }}
                />
                <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
                  <Button type="submit" variant="contained" color="primary">
                    Submit
                  </Button>
                  <Button type="button" variant="outlined" onClick={handleClear}>
                    Clear form
                  </Button>
                </Box>
                
      

                <Typography variant="caption" display="block" sx={{ mt: 6, color: 'text.secondary' }}>
                  Got something nice to say? We'd love a public review on our{' '}
                  {platform?.platform === 'ios' ? (
                    <a href={APP_STORE_URL} target="_blank" rel="noopener noreferrer">App Store</a>
                  ) : platform?.platform === 'android' ? (
                    <a href={PLAY_STORE_URL} target="_blank" rel="noopener noreferrer">Play Store</a>
                  ) : (
                    <><a href={APP_STORE_URL} target="_blank" rel="noopener noreferrer">App Store</a> or <a href={PLAY_STORE_URL} target="_blank" rel="noopener noreferrer">Play Store</a></>
                  )}{' '}
                  page.
                </Typography>

                <Typography variant="caption" display="block" sx={{display: 'flex', mt: 2, color: 'text.secondary' }}>
                    Also reach us at {contactEmail}
                    <CopyItem thingToCopy={contactEmail} />
                  </Typography>
              </Box>
            </>
          )}
        </Box>

        <iframe
          id="feedback-form-target"
          name="feedback-form-target"
          title="Form submission target"
          style={{ position: 'absolute', width: 0, height: 0, border: 0 }}
        />
      </>
    );
  }

  // Fallback: embed Google Form in iframe (e.g. post-game survey)
  return (
    <>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          bgcolor: 'background.default',
          zIndex: 2,
          position: 'absolute',
          top: 0,
          left: 0,
          padding: 2,
          paddingTop: platform.statusBarHeight + 16 + 'px',
        }}
      >
        <Typography sx={{ mb: 1 }}>
          Thank you for your thoughts! Fill out the form or email{' '}
          <Link
            to="#"
            onClick={(e) => {
              window.location.href = `mailto:${contactEmail}`;
              e.preventDefault();
            }}
          >
            {contactEmail}
          </Link>
          <CopyItem thingToCopy={contactEmail} />
        </Typography>
        {backButton}
      </Box>
      <Box sx={{ minHeight: '150px', width: '100%' }} />
      <iframe
        src={props.sourceURL}
        title="Google form"
        width="100%"
        style={{ minHeight: '830px' }}
        frameBorder="0"
        marginHeight="0"
        marginWidth="0"
      />
    </>
  );
};

export default Feedback;
